export default {
  first: 'Primera pagina',
  last: 'Ultima pagina',
  next: 'Siguiente pagina',
  previous: 'Página anterior'
}
